// supervisor-policy.ts
//
// Wires commit-owner.ts's injected `evaluatePolicy` to policy-adapter.ts's
// real decision function. policy-adapter.ts's own doc comment records the
// judgment call this file continues: no facade script is pinned for
// autopilot yet in the pack, so `runFacade` is injected here — swapping in
// a real facade later is a one-line change at THIS call site, never a
// change to commit-owner.ts's decision logic (policy-adapter.ts: "Khi P4/P5
// chốt script thật, chỉ cần trỏ facadeCommand — KHÔNG phải sửa logic quyết
// định").
//
// Default `runFacade` allows every non-push mutation — matches the fact
// that push already has its own hard review-gate check inside
// evaluatePolicy() BEFORE the facade ever runs (step 3), so an
// always-allow facade stub does not weaken the push path at all.
import { evaluatePolicy, type PolicyAdapterInput, type PolicyVerdict } from "./policy-adapter.js";

export interface SupervisorPolicyDeps {
  runFacade?: (input: PolicyAdapterInput) => Promise<{ status: number | null; stdout: string }>;
}

async function allowFacade(): Promise<{ status: number | null; stdout: string }> {
  return {
    status: 0,
    stdout: JSON.stringify({ decision: "allow", reason: "no facade pinned yet" }),
  };
}

export function buildSupervisorPolicyEvaluator(
  deps: SupervisorPolicyDeps = {},
): (input: PolicyAdapterInput) => Promise<PolicyVerdict> {
  const runFacade = deps.runFacade ?? allowFacade;
  return (input: PolicyAdapterInput) => evaluatePolicy(input, { runFacade });
}
